module.exports = __webpack_public_path__ + "img/c01_unitpeltast_Normal_ua.cd21c977.webp";